<template>
    <div class="invoice-main-content">
        <div class="customer">
            <span class="light-grey">Bill To:</span>
            <span
                class="bold-font text-uppercase"
                :class="`gradient-bg-${variant}`"
            >
                {{ customer.name }}</span
            >
            <span> {{ customer.email }}</span>
            <span> {{ customer.description }} </span>
        </div>
        <div class="inv">
            <span class="light-grey">Invoice no:</span>
            <span>#{{ invoiceNo }}</span>
        </div>
        <div class="due">
            <span class="light-grey">Billing period:</span>
            <span>{{ billingPeriod }}</span>
        </div>
        <div class="due">
            <span class="light-grey">Due date:</span>
            <span>{{ date }}</span>
        </div>
        <div class="amount">
            <span class="light-grey">Total Amount ({{ currency.code }})</span>
            <span
                class="big-font bold-font"
                :class="`gradient-bg-${variant}`"
                >{{ (total - discount) | formatCurrency(currency.code) }}</span
            >
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import currencyFormatter from 'currency-formatter';

import { format } from 'date-fns';
export default {
    name: 'InvoiceDetails',
    props: ['currency', 'variant'],
    data() {
        return {
            date: format(new Date(), 'MMM, dd yyyy'),
            billingPeriod: '',
        };
    },
    created() {
        const { year, month } = this.$route.params;
        const billingPeriodDate = new Date(year, month - 1);
        const billingPeriodFirstDay = new Date(
            billingPeriodDate.getFullYear(),
            billingPeriodDate.getMonth(),
            1
        );
        const billingPeriodLastDay = new Date(
            billingPeriodDate.getFullYear(),
            billingPeriodDate.getMonth() + 1,
            0
        );
        const billingPeriodFirstDayString =
            billingPeriodFirstDay.toLocaleDateString('en-us', {
                month: 'long',
                day: 'numeric',
            });
        const billingPeriodLastDayString =
            billingPeriodLastDay.toLocaleDateString('en-us', {
                month: 'long',
                day: 'numeric',
            });
        this.billingPeriod =
            billingPeriodFirstDayString + ' - ' + billingPeriodLastDayString;
    },
    computed: {
        ...mapGetters({
            invoiceItems: 'getInvoiceItems',
            subTotal: 'getSubTotal',
            total: 'getTotal',
            totalTaxes: 'getTotalTaxes',
            discount: 'getDiscount',
        }),
        ...mapState({
            invoiceNo: (state) => {
                if (!state.Invoice.invoice.id)
                    return (Math.random() * 1000000).toFixed(0);
                return state.Invoice.invoice.id;
            },
            customer: (state) => state.Invoice.customer,
        }),
    },
    filters: {
        formatCurrency: (value, currency) => {
            if (!value) return;

            return currencyFormatter.format(value, { code: currency });
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-main-content {
    display: flex;
    justify-content: space-between;
    width: 100%;

    & div span {
        display: block;
        text-align: left;
    }
}
</style>
